export const characters = {
    en: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        },
        {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    se: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        }, {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÅÄÖ",
            value: "ÅÄÖ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    fi: [
        {
            name: "AB",
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        }, {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÅÄÖ",
            value: "ÅÄÖ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ],
    nb: [
        {
            name: "AB", 
            value: "AB"
        },
        {
            name: "CD",
            value: "CD"
        },
        {
            name: "EF",
            value: "EF"
        },
        {
            name: "GH",
            value: "GH"
        },
        {
            name: "IJ",
            value: "IJ"
        },
        {
            name: "KL",
            value: "KL"
        },
        {
            name: "MN",
            value: "MN"
        },
        {
            name: "OP",
            value: "OP"
        },
        {
            name: "QR",
            value: "QR"
        },
        {
            name: "ST",
            value: "ST"
        },
        {
            name: "UVW",
            value: "UVW"
        },
        {
            name: "XYZ",
            value: "XYZ"
        },
        {
            name: "ÆØÅ",
            value: "ÆØÅ"
        },
        {
            name: "0-9",
            value: "1234567890"
        }
    ]
};
